import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const deletedAccountRedirectGuard: CanActivateFn = () => {
  const platform = inject(PLATFORM_ID);
  const router = inject(Router);

  if (isPlatformServer(platform)) {
    return router.navigate(['404'], {
      skipLocationChange: true,
    });
  }

  return true;
};
